<template>
	<div id="menu-bar">
		<div class="menu-bar-header">
			<div class="close">
				<a href="#" @click.prevent="closeMenu">
					<ion-icon name="ios-close"></ion-icon>
				</a>
				<div class="menu-hello">
					<div class="dateTime">
						<span class="date">{{this.appDate}}</span>
						<span class="time">{{this.appTime}}</span>
					</div>
					<span
						v-if="$store.state.user.authUser !== null"
					>Hello, {{$store.state.user.user.firstName || $store.state.user.user.email}}</span>
				</div>
			</div>
			<search></search>
		</div>
		<nav>
			<ul v-if="$store.state.user.authUser !== null" class="auth-list">
				<router-link :to="{path: `/profile/${profileRoute}`}" tag="li" active-class="is-active">
					<a>
						<img
							class="profile-photo"
							v-if="photoURL"
							v-lazy="$store.state.user.user.photoURL"
							alt="Profile picture"
						/>
						<ion-icon v-else name="ios-contact"></ion-icon>Profile
					</a>
				</router-link>
				<router-link
					v-if="$store.state.user.user.username !== ''"
					:to="{path: `/s/${profileRoute}`}"
					tag="li"
					active-class="is-active"
				>
					<a>
						<ion-icon name="logo-buffer"></ion-icon>Stack
					</a>
				</router-link>
				<li active-class="is-active">
					<a @click.prevent="showNotifications" style="position: relative;">
						<ion-icon name="ios-notifications"></ion-icon>Notifications
						<span
							v-if="notificationCount > 0"
							class="stackng-notification"
							:title="`You have ${notificationCount} Notifications`"
						></span>
					</a>
				</li>
				<li active-class="is-active" v-if="showGroup">
					<a @click.prevent="showGroups" style="position: relative;">
						<ion-icon name="ios-contacts"></ion-icon>Groups
					</a>
				</li>
				<li>
					<hr />
				</li>
				<!-- <li active-class="is-active">
					<a style="position: relative;">
						<ion-icon name="ios-rocket"></ion-icon>
						Discover
					</a>
				</li>-->
			</ul>
			<ul v-if="apiError === null">
				<li>
					<a @click="openActivityBar">
						<ion-icon name="ios-time"></ion-icon>Recent Activity
					</a>
				</li>
				<li>
					<hr />
				</li>
				<router-link to="/" tag="li" active-class="is-active" exact>
					<a id="homeLink">
						<!-- <ion-icon name="home"></ion-icon> -->
						Home
					</a>
				</router-link>
				<router-link to="/featured" tag="li" active-class="is-active">
					<a>Featured</a>
				</router-link>
				<router-link to="/business" tag="li" active-class="is-active">
					<a>Business</a>
				</router-link>
				<router-link to="/health" tag="li" active-class="is-active">
					<a>Health</a>
				</router-link>
				<router-link to="/technology" tag="li" active-class="is-active">
					<a>Technology</a>
				</router-link>
				<router-link to="/science" tag="li" active-class="is-active">
					<a>Science</a>
				</router-link>
				<router-link to="/entertainment" tag="li" active-class="is-active">
					<a>Entertainment</a>
				</router-link>
				<router-link to="/sports" tag="li" active-class="is-active">
					<a>Sports</a>
				</router-link>
				<!-- <router-link to="/world" tag="li" active-class="is-active"><a>World</a></router-link>
				<router-link to="/africa" tag="li" active-class="is-active"><a>Africa</a></router-link>-->
				<li>
					<a class="topic-link" @click.prevent="openTopics">Topics</a>
					<ion-icon v-if="!showTopics" class="topic-arrow" name="ios-arrow-down"></ion-icon>
					<ion-icon v-else class="topic-arrow" name="ios-arrow-up"></ion-icon>
					<div v-show="showTopics" class="topic-lists">
						<div class="topic-list-a">
							<ul class="topic-list">
								<router-link to="/agriculture" tag="li" active-class="is-active">
									<a>Agriculture</a>
								</router-link>
								<router-link to="/art" tag="li" active-class="is-active">
									<a>Art</a>
								</router-link>
								<router-link to="/bokoharam" tag="li" active-class="is-active">
									<a>Boko Haram</a>
								</router-link>
								<router-link to="/corruption" tag="li" active-class="is-active">
									<a>Corruption</a>
								</router-link>
								<!-- <router-link to="/cuisine" tag="li" active-class="is-active"><a>Cuisine</a></router-link> -->
								<router-link to="/culture" tag="li" active-class="is-active">
									<a>Culture</a>
								</router-link>
								<router-link to="/economy" tag="li" active-class="is-active">
									<a>Economy</a>
								</router-link>
							</ul>
						</div>
						<div class="topic-list-b">
							<ul class="topic-list">
								<router-link to="/education" tag="li" active-class="is-active">
									<a>Education</a>
								</router-link>
								<router-link to="/covid-19" tag="li" active-class="is-active">
									<a>Corona Virus</a>
								</router-link>
								<router-link to="/environment" tag="li" active-class="is-active">
									<a>Environment</a>
								</router-link>
								<router-link to="/family" tag="li" active-class="is-active">
									<a>Family</a>
								</router-link>
								<!-- <router-link to="/feminism" tag="li" active-class="is-active"><a>Feminism</a></router-link> -->
								<router-link to="/fitness" tag="li" active-class="is-active">
									<a>Fitness</a>
								</router-link>
								<router-link to="/politics" tag="li" active-class="is-active">
									<a>Politics</a>
								</router-link>
							</ul>
						</div>
					</div>
				</li>
				<router-link to="/opinions" event tag="li" active-class="is-active">
					<a>
						Opinions
						<span class="tag is-danger coming-soon">coming soon</span>
					</a>
				</router-link>
			</ul>
			<ul>
				<li>
					<hr />
				</li>
				<router-link to="/about" tag="li" active-class="is-active">
					<a>About StackNG</a>
				</router-link>
				<router-link to="/reach-out" tag="li" active-class="is-active">
					<a>Reach Out</a>
				</router-link>
			</ul>
		</nav>
		<div :class="[apiError === null ? menuRel : menuAbs]">
			<app-footer></app-footer>
		</div>
	</div>
</template>

<script>
import Search from "./search/Search.vue";
import Footer from "./Footer.vue";
import { groupsMixin } from "../mixins/groupsMixin";
import { notificationsMixin } from "../mixins/notificationsMixin";
import { startTime, getDate } from "../resources/utilities";

export default {
	mixins: [groupsMixin, notificationsMixin],
	data() {
		return {
			appTime: "",
			appDate: "",
			menuAbs: "menu-abs",
			menuRel: "menu-rel",
			showTopics: false
		};
	},
	components: {
		appFooter: Footer,
		Search
	},
	mounted() {
		startTime(this.appTime);
		getDate(this.appDate);
	},
	computed: {
		profileRoute() {
			if (
				this.$store.state.user.authUser !== null &&
				this.$store.state.user.user.username
			) {
				return this.$store.state.user.user.username;
			} else {
				return this.$store.state.user.authUser.uid;
			}
		},
		photoURL() {
			return this.$store.state.user.user.photoURL === "" ||
				this.$store.state.user.user.photoURL === undefined
				? false
				: true;
		},
		apiError() {
			return this.$store.state.app.app.apiError;
		},
		notificationCount() {
			return this.$store.getters.getNotifications.length;
		},
		showGroup() {
			return (
				this.$store.state.user.authUser !== null &&
				this.$store.state.user.user.username !== ""
			);
		}
	},
	methods: {
		closeMenu() {
			this.$store.state.app.app.menuOpen = false;
		},
		openTopics() {
			this.showTopics ? (this.showTopics = false) : (this.showTopics = true);
		},
		showNotifications() {
			this.closeMenu();

			setTimeout(() => {
				this.showNotificationsModal();
			}, 500);
		},
		showGroups() {
			this.closeMenu();

			setTimeout(() => {
				this.showGroupsModal();
			}, 500);
		},
		openActivityBar() {
			this.closeMenu();
			this.$store.state.app.app.activityBarOpen = true;
		}
	}
};
</script>

<style lang="css" src="../styles/appStyles.css"></style>
<style scoped>
#menu-bar {
	position: fixed;
	left: 0;
	top: 0;
	height: 100vh;
	min-height: 100vh;
	overflow: scroll;
	width: 350px;
	background-color: #101010;
	z-index: 20;
	padding-top: 0px;
	transition: all 0.5s ease-in-out;
	box-shadow: 7px 0px 40px -8px rgba(0, 0, 0, 0.75);
}

.menu-bar-header {
	position: sticky;
	position: -web-sticky;
	padding: 20px;
	top: 0;
	background-color: #171717;
	width: 100%;
	z-index: 10; /*Fixed stack icon overlapping menu header */
}

.close {
	display: flex;
	align-items: center;
}

.close div {
	vertical-align: top;
	float: right;
}

.close ion-icon {
	font-size: 40px;
	color: #51c715;
	margin-left: -10px;
}

.menu-hello {
	display: inline-block;
	font-size: 11px;
	width: 100%;
	text-align: right;
	color: #fff;
}

.sign-out-link {
	color: #fff;
	font-weight: 700;
	border: 2px solid red;
	background-color: red;
	padding: 3px 10px 4px;
	border-radius: 10px;
	font-size: 13px;
	vertical-align: -webkit-baseline-middle;
	transition: 0.3s all ease-in-out;
}

.sign-out-link:hover {
	color: #fff;
	border-color: red;
}

.auth-list {
	margin-top: 20px;
}

nav {
	padding-left: 20px;
	padding-right: 20px;
	padding-bottom: 50px;
}

nav li {
	padding: 20px 0px 0px;
	margin-bottom: 5px;
}

nav a {
	color: #fff;
	font-size: 23px;
	font-family: "Avenir", "Nunito", sans-serif;
	font-weight: 600;
	/* border-bottom: 2px solid #171717; */
	transition: 0.3s ease all;
}

.topic-arrow {
	font-size: 20px;
}

.topic-lists {
	display: inline-flex;
	width: 100%;
	padding-top: 20px;
	transition: 0.3s ease all;
}

.topic-list-a,
.topic-list-b {
	width: 50%;
}

.topic-list-a {
	margin-right: 20px;
}

.topic-list li {
	padding: 5px 0px;
}

.topic-list li a {
	font-size: 15px;
}

.coming-soon {
	font-size: 10px;
	border-radius: 15px;
	padding: 0px 8px;
	margin-left: 10px;
	vertical-align: middle;
	background-color: red !important;
}

.menu-abs {
	position: absolute;
	width: 100%;
	bottom: 0;
}

.menu-rel {
	position: relative;
}

nav a:hover,
li.is-active a {
	color: #51c715;
	padding: 4px 10px;
	background-color: #083308;
	border-radius: 25px;
}

ul ion-icon {
	font-size: 27px;
	vertical-align: sub;
	margin-right: 10px;
}

hr {
	height: 1px;
	background-color: #000;
	margin: 5px 0px;
}

.stackng-notification {
	top: 4px;
	left: 0px;
	border-color: #171717;
}

.profile-photo {
	height: 27px;
	width: 27px;
	border-radius: 50%;
	margin-right: 10px;
	object-fit: cover;
	vertical-align: sub;
}

@media only screen and (max-width: 940px) {
	.menu-bar-header {
		padding-top: 8px;
	}
}

@media only screen and (max-width: 768px) {
	#menu-bar {
		width: 88%;
	}

	.menu-bar-header {
		padding-top: 8px;
	}

	.topic-list li a {
		font-size: 13px;
	}
}

@media only screen and (max-width: 540px) {
	nav a {
		font-size: 17px;
	}

	ul ion-icon {
		font-size: 20px;
	}

	.profile-photo {
		height: 18px;
		width: 18px;
	}

	.stackng-notification {
		height: 10px !important;
		width: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/MenuBar.vue